import Prismic from '@prismicio/client'

const apiEndpoint = process.env.REACT_APP_PRISMICIO_API_ENDPOINT
const accessToken = process.env.REACT_APP_PRISMICIO_ACCESS_TOKEN

const PrismicClient = Prismic.client(apiEndpoint, { accessToken })

const getActivity = id => PrismicClient.getByID(id).then(response => response.data)
const getActivities = ids => PrismicClient.getByIDs(ids).then(res => res.results)
const getEverithyng = () => PrismicClient.query('').then(res => res.results)

export {
  getActivity,
  getActivities,
  getEverithyng
}
